import * as PIXI from "pixi.js"
import { containers, gameAssets } from "./gameUI"
import { resolveAndKillTweens } from "./utility"
import gsap from "gsap"
import { config } from "./appConfig"

const coins = [
'coin1', 
'coin2', 
'coin3', 
'coin4', 
'coin5', 
'coin6', 
'coin7', 
'coin8', 
'coin9', 
'coin10',
'coin11',
'coin12',
'coin13',
'coin14',
'coin15',
'coin16',
'coin17',
// 'coin18',
]

const animationsConst = ['pcos', 'dg', 'dgx']

let delayCall = null
const delayedCalls = []

const getAnimName = () => {
    const index = Math.floor(Math.random() * animationsConst.length)
    const animationName = animationsConst[index]
    return PIXI.Assets.get('dgxHubCoins').animations[animationName]
}
export const setupCoins = () => {
    setupCoinAnimation(0, getAnimName(), 1200, 0)
    setupCoinAnimation(1, getAnimName(), 400, 900)
    setupCoinAnimation(2, getAnimName(), -400, 900)
    setupCoinAnimation(3, getAnimName(), -1200, 0)
    setupCoinAnimation(4, getAnimName(), -400, -900)
    setupCoinAnimation(5, getAnimName(), 400, -900)
    setupCoinAnimation(6, getAnimName(), 1200 + 200, 0 + 200)
    setupCoinAnimation(7, getAnimName(), 400 + 200, 900 + 200)
    setupCoinAnimation(8, getAnimName(), -400 - 200, 900 + 200)
    setupCoinAnimation(9, getAnimName(), -1200 - 200, 0 + 200)
    setupCoinAnimation(10, getAnimName(), -400 - 200, -900 - 200)
    setupCoinAnimation(11, getAnimName(), 400 + 200, -900 - 200)
    setupCoinAnimation(12, getAnimName(), 1200 + 400, 0 + 400)
    setupCoinAnimation(13, getAnimName(), 400 + 400, 900 + 400)
    setupCoinAnimation(14, getAnimName(), -400 - 400, 900 + 400)
    setupCoinAnimation(15, getAnimName(), -1200 - 400, 0 + 400)
    setupCoinAnimation(16, getAnimName(), -400 - 400, -900 - 400)
    setupCoinAnimation(17, getAnimName(), 400 + 400, -900 - 400)
}

const delayValue = () => Math.random() + 2

const setupCoinAnimation = (index, animation, x ,y) => {
    const gameObject = coins[index]
    if(!gameAssets[gameObject]) gameAssets[gameObject] = new PIXI.AnimatedSprite(animation)
        gameAssets[gameObject].visible = false
        gameAssets[gameObject].animationSpeed = 0.3
        gameAssets[gameObject].anchor.set(0.5)
        if(index > 6) {
            gameAssets[gameObject].angle = 5
            x = x + 300
            y = y + 300
        }
        if(index > 12) {
            gameAssets[gameObject].angle = 10
            x = x + 600
            y = y + 600
        }
        const width = gameAssets[gameObject].width
        const height = gameAssets[gameObject].height
        
        gameAssets[gameObject].initialHeight = gameAssets[gameObject].height
        gameAssets[gameObject].initialWidth = gameAssets[gameObject].width 
        containers.coinsContainer.addChild(gameAssets[gameObject])
        // gameAssets[gameObject].resize = (w, h) => {
        //     const expandFactor = 0.1
        //     const scale = scaleFactor(gameAssets.gameScreen.width, width)
        //     containers.coinsContainer.x = config.logicalWidth  
        //     containers.coinsContainer.y = config.logicalHeight 
        //     containers.coinsContainer.scale.set(1)
        //      gameAssets[gameObject].width = gameAssets[gameObject].width * scale * expandFactor
        //      gameAssets[gameObject].height = gameAssets[gameObject].height * scale * expandFactor
        // } 
    
        containers.coinsContainer.x = config.logicalWidth * 0.5  
        containers.coinsContainer.y = config.logicalHeight * 0.4
        gameAssets[gameObject].width = width * 0.6
        gameAssets[gameObject].height = height * 0.6
    
    
        gameAssets[gameObject].playCoin = async(coinIndex) => {
            gameAssets[gameObject].textures = PIXI.Assets.get('dgxHubCoins').animations[animationsConst[coinIndex]]
            gameAssets[gameObject].visible = true

            resolveAndKillTweens(gameAssets[gameObject])
            const tl = gsap.timeline()
            await tl.to(gameAssets[gameObject], {
                x: x ,
                y: y ,
                width: width * 1.4 * 0.5,
                height: height * 1.4 * 0.5,
                duration: 0.6,
                ease: 'none',
                repeat: -1
            })
        }

        gameAssets[gameObject].stopCoin = () => {
            resolveAndKillTweens(gameAssets[gameObject])
            gameAssets[gameObject].stop()
            gameAssets[gameObject].visible = false
            gameAssets[gameObject].x = 0
            gameAssets[gameObject].y = 0
            gameAssets[gameObject].width = width * 0.6
            gameAssets[gameObject].height = height * 0.6
        }
    
        // gameAssets[gameObject].play()
}

export const playCoinAnimation = (coinIndex) => {
    stopCoinAnimation()
    for (let i = 0; i < coins.length; i++) {
        const coin = coins[i]
        let delay = 0
        if(i > 6) delay = 0.5
        if(i > 12) delay = 1

        delayCall = gsap.delayedCall(delay, ()=>{
            gameAssets[coin]?.playCoin(coinIndex)
            gameAssets[coin].play()
        })

        delayedCalls.push(delayCall)
        
    }
}
    // coins.forEach(coin => {
    //     gameAssets[coin]?.playCoin()
    //     gameAssets[coin].play()
    // });

export const stopCoinAnimation = () => {
    coins.forEach(coin => {
        gameAssets[coin].stopCoin()
    })

    delayedCalls.forEach(c => {
        if(c) c.kill()
    })
}







